import { ChevronDown } from '@wix/wix-ui-icons-common';
import React from 'react';
import { ReviewsSortBy } from '../../../../../enums/marketplace-enums';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { DropdownBase, TextButton } from '@wix/design-system';
import { composer } from '../../../../../component-decorators/composer';

interface ISortDropDownProps extends Partial<WithTranslationProps> {
  sortBy(sortingMethod: string): void;
  isMobile: boolean;
}

export const SortDropDown = composer()
  .withTranslation()
  .compose(({ t, ...props }: ISortDropDownProps) => (
    <SortDropDownComponent t={t} {...props} />
  ));

class SortDropDownComponent extends React.Component<ISortDropDownProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      currentSortMethod: this.props.t('solution.page.reviewsBtnRecent'),
    };
    this.onSelectHandler = this.onSelectHandler.bind(this);
  }

  onSelectHandler = (selectedOption: { id: string; value: string }): void => {
    if (
      selectedOption &&
      selectedOption.value !== this.state.currentSortMethod
    ) {
      this.setState({ currentSortMethod: selectedOption.id });
      this.props.sortBy(selectedOption.id);
    }
  };
  render() {
    return (
      <div>
        <DropdownBase
          dataHook="drop-down-base"
          onSelect={this.onSelectHandler}
          initialSelectedId={ReviewsSortBy.MostRecent}
          options={[
            {
              id: ReviewsSortBy.MostRecent,
              value: this.props.t('solution.page.reviewsBtnRecent'),
            },
            {
              id: ReviewsSortBy.MostHelpful,
              value: this.props.t('solution.page.reviewsBtnHelpful'),
            },
            {
              id: ReviewsSortBy.Rating,
              value: this.props.t('solution.page.reviewsBtnRating'),
            },
          ]}
        >
          {({ toggle, selectedOption }) => {
            return (
              <TextButton
                skin="dark"
                weight="normal"
                onClick={toggle}
                suffixIcon={<ChevronDown />}
                priority="secondary"
                dataHook="sort-drop-down-btn"
                size="medium"
              >
                {(selectedOption && selectedOption.value) ||
                  this.state.currentSortMethod}
              </TextButton>
            );
          }}
        </DropdownBase>
      </div>
    );
  }
}
